import React from 'react';
import useMenu from '../useMenu';
import useTranslations from '../useTranslations';

import * as S from './styled';

const Navigation = () => {
  const menuItems = useMenu();
  const { buttonUrl, button } = useTranslations();

  return (
    <>
      <S.Navigation>

        <div>
        {menuItems.map((menu, index) => (
          <S.NavigationLink
            to={menu.link}
            aria-label={menu.name}
            activeClassName="active"
            key={`${menu.link}${index}`}
            >
            {menu.name}
          </S.NavigationLink>
        ))}
        </div>

        <S.NavigationButton href={buttonUrl}  rel="noopener noreferrer">
          {button}
        </S.NavigationButton>

      </S.Navigation>
    </>
  );
};

export default Navigation;
